const absoluteURLRegExp = new RegExp('(^[a-zA-Z][a-zA-Zd+-.]*:)|(^//)');
export const absoluteURL = (url: string) => absoluteURLRegExp.test(url);
